import React, { useEffect } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import './GeneralRestaurantData.scss';
import { useSelector } from 'react-redux';
import { isNil } from 'lodash-es';
import { toast } from 'react-toastify';
import Lottie from 'lottie-react';
import { QRCodeSVG } from 'qrcode.react';
import { selectSelectedRestaurantId } from '../../store/auth/selectors';
import { useGetRestaurantByIdQuery, useUpdateRestaurantMutation } from '../../store/restaurant/restaurantApi';
import loader from '../../assets/lotties/loader.json';

type Inputs = {
	name: string;
	phone: string;
};

const schema = yup.object({
	name: yup.string().required('Restaurant name is required'),
	phone: yup.string().required('Phone is required'),
});

export const GeneralRestaurantData = (): JSX.Element => {
	const selectedRestaurantId = useSelector(selectSelectedRestaurantId);
	const { data: restaurant, isLoading: isLoadingRestaurant } = useGetRestaurantByIdQuery(selectedRestaurantId, { skip: !selectedRestaurantId });
	const [updateRestaurant] = useUpdateRestaurantMutation();

	const {
		register,
		handleSubmit,
		reset,
		formState: { errors },
	} = useForm<Inputs>({
		resolver: yupResolver(schema), // connect yup
		defaultValues: {
			name: restaurant?.name || '',
			phone: restaurant?.phone || '',
		},
	});

	// hydrate the form once restaurant data is fetched
	useEffect(() => {
		if (!isNil(restaurant)) {
			reset({
				name: restaurant.name ?? '',
				phone: restaurant.phone ?? '',
			});
		}
	}, [restaurant, reset]);

	const onFormSubmit: SubmitHandler<Inputs> = (data) => {
		console.log(data);
		updateRestaurant({ id: selectedRestaurantId, ...data, allowTableOrders: true, allowSessions: true })
			.then((res) => {
				console.log('Restaurant updated:', res);
				toast.success('העידכון בוצע בהצלחה!');
			})
			.catch((err) => {
				console.error('Failed to update restaurant:', err);
				toast.error('שגיאת עדכון');
			});
	};

	return (
		<div className="generalRestaurantDataContainer">
			{isLoadingRestaurant ? (
				<Lottie animationData={loader} loop style={{ width: '10rem' }} />
			) : (
				<>
					<form onSubmit={handleSubmit(onFormSubmit)}>
						<div className="formGroup">
							<label>שם המסעדה</label>
							<input {...register('name')} />
							{errors.name && <p style={{ color: 'red' }}>{errors.name.message}</p>}
						</div>
						<div className="formGroup">
							<label>טלפון</label>
							<input {...register('phone')} />
							{errors.phone && <p style={{ color: 'red' }}>{errors.phone.message}</p>}
						</div>
						<button type="submit">שמור</button>
					</form>

					<QRCodeSVG value={`${process.env.REACT_APP_CLIENT_URL}/?restaurantId=${selectedRestaurantId}&isGeneralNoTableQr=true`} />
				</>
			)}
		</div>
	);
};
